function submitVariantForm(variantId, formId) {
  try {
    // Seleccionar el input de la variante
    const variantInput = document.getElementById('variant-' + variantId);
    
    if (variantInput && !variantInput.disabled && variantInput.dataset.available === 'true') {
      // Marcar el input como seleccionado
      variantInput.checked = true;
      
      // Disparar evento change para compatibilidad
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Pequeño delay para asegurar que el change se procese
      setTimeout(function() {
        // Encontrar y enviar el formulario
        const form = document.getElementById(formId);
        if (form) {
          const submitButton = form.querySelector('.submit-button');
          if (submitButton && !submitButton.disabled) {
            submitButton.click();
          }
        }
      }, 50);
    }
  } catch (error) {
    console.error('Error submitting variant form:', error);
  }
}
